// extracted by mini-css-extract-plugin
export var childrenContainer = "_c5-0";
export var virtualScrollArea = "_c5-1";